// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"static-page_wrapper__n65Lz","heading":"static-page_heading__R61bt","content":"static-page_content__q1_AN","center":"static-page_center__4yIXS"};